import { render, staticRenderFns } from "./table-hxrgs.vue?vue&type=template&id=ffdaefd8&scoped=true"
import script from "./table-hxrgs.vue?vue&type=script&lang=js"
export * from "./table-hxrgs.vue?vue&type=script&lang=js"
import style0 from "./table-hxrgs.vue?vue&type=style&index=0&id=ffdaefd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdaefd8",
  null
  
)

export default component.exports